// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"1ebf3bb4","213":"333ab1f5","422":"2330fe8c","455":"86fe5b93","591":"c44fba98","640":"52ec5720"}[chunkId] + ".chunk.js";
};